import { render, staticRenderFns } from "./buindingLeftCenter.vue?vue&type=template&id=080a7b86&"
import script from "./buindingLeftCenter.vue?vue&type=script&lang=js&"
export * from "./buindingLeftCenter.vue?vue&type=script&lang=js&"
import style0 from "./buindingLeftCenter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports